
import React from "react";
import { Outlet } from "react-router-dom";


function NoLayout()
{
    return(<Outlet/>)
}
export default NoLayout;